import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useHistory } from 'react-router-dom';

const Countdown = ({ keepCarDecisionDate, recordId }) => {
  const history = useHistory();
  function calculateTimeLeft() {
    const startAt = new Date(moment(keepCarDecisionDate?.date).format('YYYY-MM-DD HH:mm:ss'));
    const dateExpired = new Date(startAt.getTime() + 48 * 60 * 60 * 1000);
    const difference = dateExpired - new Date();
    let timeLeft = {};
    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }
    return timeLeft;
  }

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const timerComponents = Object.keys(timeLeft).map((interval) => {
    if (!timeLeft[interval]) {
      return null;
    }
    return (
      <span key={interval}>
        {timeLeft[interval]} {interval}{' '}
      </span>
    );
  });
  return (
    <div className="font-weight-bold">
      {keepCarDecisionDate && timerComponents.length ? timerComponents : history.push(`/files/${recordId}`)}
    </div>
  );
};

Countdown.propTypes = {
  recordId: PropTypes.number.isRequired,
  keepCarDecisionDate: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default Countdown;
